const SHOW_MODAL = 'classpass/modals/SHOW';
export const HIDE_MODAL = 'classpass/modals/HIDE';

export const showModal = (name, props) => ({
  type: SHOW_MODAL,
  name,
  props: props || {},
});

export const hideModal = name => ({ type: HIDE_MODAL, name });
export const selectActiveModalName = state => state.modals.modalName;
export const selectActiveModalProps = state => state.modals.modalProps;

const initialState = {
  modalName: null,
  modalProps: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_MODAL: {
      return {
        ...state,
        modalName: action.name,
        modalProps: action.props,
      };
    }
    case HIDE_MODAL:
      return action.name === state.modalName ? initialState : state;
    default:
      return state;
  }
}
